export const unknownError = 'Si è verificato un errore. Se il problema persiste, contattare il supporto.';
